import { CountryCode } from '@weave/schema-gen-ts/dist/schemas/forms-digital/weave_digital_forms.pb';
import { i18next } from '@frontend/i18n';
import { PostalCodeLocale } from '@frontend/design-system';

export const countryCodeToPostalCodeLocale = (countryCode: CountryCode): PostalCodeLocale => {
  switch (countryCode) {
    case CountryCode.CA:
      return PostalCodeLocale.CA;
    case CountryCode.US:
    default:
      return PostalCodeLocale.US;
  }
};

export const postalCodeLocaleToCountryCode = (locale: PostalCodeLocale): CountryCode => {
  switch (locale) {
    case PostalCodeLocale.CA:
      return CountryCode.CA;
    case PostalCodeLocale.US:
    default:
      return CountryCode.US;
  }
};

export const LOCALE_LIST = [
  {
    name: i18next.t('English', { ns: 'digital-forms-experience' }),
    value: 'en',
  },
  {
    name: i18next.t('Spanish', { ns: 'digital-forms-experience' }),
    value: 'es',
  },
];

export const getZipCodeLabel = (locale: PostalCodeLocale): string => {
  // TODO: confirm removal of this whether can depend on translation alone or not
  if (i18next.language !== 'en') {
    return i18next.t('ZIP', { ns: 'digital-forms-experience' });
  }

  switch (locale) {
    case PostalCodeLocale.CA:
      return i18next.t('Postal Code', { ns: 'digital-forms-experience' });
    case PostalCodeLocale.US:
    default:
      return i18next.t('ZIP Code', { ns: 'digital-forms-experience' });
  }
};

export const getStateLabel = (locale: PostalCodeLocale): string => {
  // TODO: confirm removal of this whether can depend on translation alone or not
  if (i18next.language !== 'en') {
    return i18next.t('State', { ns: 'digital-forms-experience' });
  }

  switch (locale) {
    case PostalCodeLocale.CA:
      return i18next.t('Province', { ns: 'digital-forms-experience' });
    case PostalCodeLocale.US:
    default:
      return i18next.t('State', { ns: 'digital-forms-experience' });
  }
};
